import React from 'react';
import Icon from 'material-ui/Icon';
import Typography from 'material-ui/Typography';

const MessageCard = ({flexDirection, icon, message}) =>
    (<div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
        <div style={{display:'flex', flexDirection, justifyContent:'center', textAlign:'center', verticalAlign:'middle'}}>
            <Icon style={{margin:'10px'}}>{icon}</Icon>
            <Typography variant="subheading" color="inherit" style={{margin:'5px'}}>{message}</Typography>
        </div>
    </div>);

export default MessageCard;



// WEBPACK FOOTER //
// ./src/MessageCard.js